<template>
    <div class="pageBox">
        <PageComponent publicTemplateName="报考未学习" :publicStatus="1500"></PageComponent>
    </div>
</template>

<script>
import PageComponent from "./PageComponent"
export default {
    components: {PageComponent},
    data() {
        return{
            
        }
    },
    methods: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
}
</script>

<style lang="stylus" scoped>
    
</style>